// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Normal Table */
/* Index */

.screener-table-header-index {
  z-index: 3 !important;
  position: relative !important;
}

.screener-table-header-index,
.screener-table-index {
  width: 40px !important;
  min-width: 40px !important;
  max-width: 40px !important;
  position: -webkit-sticky;
  position: sticky !important;
  left: 0px;
  background-color: var(--surface-primary);
  box-sizing: content-box !important;
}

.screener-table-header-index {
  text-align: end !important;
}

.screener-table-index {
  text-align: center !important;
}

.screener-table-header-index-container {
  width: 100%;
  padding-left: 16px;
  text-align: left;
}

/* Country */
.screener-table-header-country {
  z-index: 3 !important;
  position: relative !important;
}

.screener-table-header-country,
.screener-table-country {
  width: 44px !important;
  min-width: 44px !important;
  max-width: 44px !important;
  position: -webkit-sticky;
  position: sticky !important;
  left: 72px;
  background-color: var(--surface-primary);
}

.screener-table-country {
  text-align: center !important;
  vertical-align: middle !important;
}

.screener-table-cell-country {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 0px 16px 0px 8px !important;
}

.screener-table-cell-country svg {
  width: 20px !important;
  height: 20px !important;
}

/* Ticker */
.screener-table-header-ticker-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.screener-table-header-ticker-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  gap: 2px;
}

.screener-table-header-ticker {
  z-index: 3 !important;
  position: relative !important;
}

.screener-table-header-ticker,
.screener-table-ticker {
  width: 85px !important;
  min-width: 85px !important;
  max-width: 85px !important;
  padding-right: 16px !important;
  position: -webkit-sticky;
  position: sticky !important;
  left: 116px;
  background-color: var(--surface-primary);
  box-sizing: content-box !important;
}

.screener-table-ticker {
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  color: var(--text-ticker) !important;
}

.screener-table-cell-ticker {
  width: fit-content;
  cursor: pointer;
}

/* Company Name */
.screener-table-header-name {
  z-index: 3 !important;
  position: relative !important;
}

.screener-table-header-name-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.screener-table-header-name-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}

.screener-table-header-name,
.screener-table-name {
  width: 200px !important;
  min-width: 200px !important;
  max-width: 200px !important;
  position: -webkit-sticky;
  position: sticky !important;
  left: 217px;
  background-color: var(--surface-primary);
  white-space: nowrap !important;
}

/* .screener-table-header-name::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 1px;
    background-color: #E0E0E0;
    z-index: 4;
    pointer-events: none;
} */

.screener-table-name {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  box-sizing: border-box !important;
  position: relative;
  width: 200px !important;
  min-width: 200px !important;
  max-width: 200px !important;
}

.screener-table-cell-name {
  color: var(--text-instrument);
}

.screener-table-name > * {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.screener-table-name::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 1px;
  background-color: #e0e0e0;
  z-index: 4;
  pointer-events: none;
}

/* Today */
.screener-table-header-today,
.screener-table-today {
  padding-left: 16px !important;
  width: 65px !important;
  min-width: 65px !important;
  max-width: 65px !important;
  text-align: right !important;
  overflow: hidden;
  box-sizing: content-box !important;
}

.screener-table-today-chart {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.screener-table-today img {
  width: 100% !important;
  height: 32px !important;
  min-height: 32px !important;
  object-fit: contain;
  display: block;
}

/* Last price */
.screener-table-header-last {
  min-width: 110px !important;
}

.screener-table-header-last-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
}

.screener-table-header-last,
.screener-table-last {
  padding-left: 16px !important;
  text-align: right !important;
}

/* Ccy */
.screener-table-header-ccy {
  padding-left: 16px !important;
  width: 48px !important;
  text-align: right !important;
}

.screener-table-header-ccy-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
}

.screener-table-ccy {
  font-weight: 400 !important;
  font-size: 12px !important;
  line-height: 20px !important;
  text-align: right !important;
  color: var(--text-secondary) !important;
}

/* %Chg */

.screener-table-pc {
  padding-left: 16px !important;
}

.screener-table-header-pc {
  min-width: 80px !important;
  text-align: right !important;
}

.screener-table-header-pc-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: start;
  height: 100%;
  cursor: pointer;
}

.screener-table-cell-pc {
  color: var(--text-unchg-color) !important;
  font-weight: 400 !important;
  text-align: right !important;
}

.screener-table-cell-pc.positive {
  color: var(--text-up-color) !important;
}

.screener-table-cell-pc.negative {
  color: var(--text-down-color) !important;
}

/* Compact Table */
.screener-compact-table-header-name,
.screener-compact-table-name {
  border-right: 1px solid var(--border-tertiary) !important;
  white-space: nowrap !important;
}

.screener-compact-table-cell-name-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.screener-compact-table-cell-ticker {
  width: fit-content;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-decoration: underline;
  color: var(--text-ticker);
  cursor: pointer;
}

.screener-compact-table-cell-name {
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: var(--text-primary);
}

/* Today */
.screener-compact-table-header-today,
.screener-compact-table-today {
  padding-left: 16px !important;
  width: 65px !important;
  min-width: 65px !important;
  max-width: 65px !important;
  text-align: right !important;
  overflow: hidden;
  box-sizing: border-box !important;
}

.screener-compact-table-today-chart {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.screener-compact-table-today img {
  width: 100% !important;
  height: 32px !important;
  min-height: 32px !important;
  object-fit: contain;
  display: block;
}

/* Last price */
.screener-compact-table-header-last {
  min-width: 110px !important;
  text-align: right !important;
}

.screener-compact-table-cell-last-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
}

.screener-compact-table-cell-last {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);
}

.screener-compact-table-cell-last-ccy {
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #3c3c4380;
}

/* %Chg */
.screener-compact-table-header-pc {
  min-width: 80px !important;
  text-align: right !important;
}

.screener-compact-table-header-pc-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
}

.screener-compact-table-cell-pc-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
}

.screener-compact-table-cell-pc {
  font-weight: 400 !important;
  text-align: right !important;
}

.screener-compact-table-cell-pc.positive {
  color: var(--text-up-color) !important;
}

.screener-compact-table-cell-pc.negative {
  color: var(--text-down-color) !important;
}

.screener-compact-table-cell-nc {
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: var(--text-primary);
}

/* ---------------------------- Small Screen Table ---------------------------- */
.screener-small-screen-table-header-name,
.screener-small-screen-table-header-ticker {
  z-index: 3 !important;
  position: relative !important;
}

.screener-small-screen-table-header-name-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.screener-small-screen-table-header-name-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}

.screener-small-screen-table-header-ticker {
  position: -webkit-sticky;
  position: sticky !important;
  width: 89px !important;
  max-width: 89px !important;
  left: 0px;
  background-color: var(--surface-primary);
  box-sizing: border-box !important;
  padding-left: 16px !important;
  padding-bottom: 8px !important;
}

.screener-small-screen-table-header-name {
  position: -webkit-sticky;
  position: sticky !important;
  width: 81px !important;
  max-width: 81px !important;
  left: 89px;
  background-color: var(--surface-primary);
  box-sizing: border-box !important;
  padding-bottom: 8px !important;
}

.screener-small-screen-table-name {
  position: -webkit-sticky;
  position: sticky !important;
  width: 170px !important;
  max-width: 170px !important;
  left: 0px;
  background-color: var(--surface-primary);
  box-sizing: border-box !important;
}

.screener-small-screen-table-name {
  overflow: hidden !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
}

.screener-small-screen-table-name::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 1px;
  background-color: #e0e0e0;
  z-index: 4;
  pointer-events: none;
}

.screener-small-screen-table-cell-name-container {
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  overflow: hidden;
}

.screener-small-screen-table-cell-name-icon {
  padding: 4px 16px 0px 0px;

  svg {
    width: 20px;
    height: 20px;
  }
}

.screener-small-screen-table-cell-name-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  cursor: auto;
}

.screener-small-screen-table-cell-ticker {
  width: fit-content;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-ticker);
  cursor: pointer;
}

.screener-small-screen-table-cell-name {
  width: 100%;
  min-width: 0;

  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--text-instrument);

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

/* Today */
.screener-small-screen-table-header-today {
  position: relative;
}

.screener-small-screen-table-header-today,
.screener-small-screen-table-today {
  padding-left: 16px !important;
  width: 65px !important;
  min-width: 65px !important;
  max-width: 65px !important;
  text-align: right !important;
  overflow: hidden;
  box-sizing: border-box !important;
}

.screener-small-screen-table-today-chart {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.screener-small-screen-table-today img {
  width: 100% !important;
  height: 32px !important;
  min-height: 32px !important;
  object-fit: contain;
  display: block;
}

/* Last price */
.screener-small-screen-table-header-last {
  position: relative;
  text-align: right !important;
  min-width: 65px !important;
  padding-left: 16px !important;
}

.screener-small-screen-table-header-last-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
}

.screener-small-screen-table-last {
  padding-left: 16px !important;
}

.screener-small-screen-table-cell-last-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
}

.screener-small-screen-table-cell-last {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);
}

/* Ccy */
.screener-small-screen-table-header-ccy {
  position: relative;
  text-align: right !important;
  min-width: 65px !important;
  padding-left: 16px !important;
}

.screener-small-screen-table-header-ccy-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
}

.screener-small-screen-table-cell-ccy {
  text-align: right;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #3c3c4380;
}

/* %Chg */
.screener-small-screen-table-pc {
  padding-left: 16px !important;
}

.screener-small-screen-table-header-pc {
  position: relative;
  text-align: right !important;
  min-width: 65px !important;
  padding-left: 16px !important;
}

.screener-small-screen-table-header-pc-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
}

.screener-small-screen-table-cell-pc {
  text-align: right;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #1e1f2f;
}

.screener-small-screen-table-cell-pc.positive {
  color: var(--text-up-color) !important;
}

.screener-small-screen-table-cell-pc.negative {
  color: var(--text-down-color) !important;
}

/* Advanced */
.screener-table-header-advanced {
  min-width: 100px !important;
  text-align: right !important;
  padding-left: 16px !important;
}

.screener-table-header-advanced-container {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: flex-end;
}

.screener-table-header-advanced-wrapper {
  cursor: pointer;
}

.screener-table-header-advanced-title .screener-table-sorting {
  flex-shrink: 0;
}

.screener-table-header-advanced-title {
  max-width: 138px;
  gap: 2px;
  display: flex;
  align-items: center;
  text-align: right;
  white-space: nowrap;
}

.screener-table-header-advanced-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.screener-table-advanced {
  padding-left: 16px !important;
  text-align: right !important;
}

.screener-table-advanced-score {
  width: 40px;
  height: 24px;

  justify-self: flex-end;
  background-color: var(--surface-secondary);

  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  color: var(--text-primary);
}

.screener-table-advanced-cell-container {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: flex-end;
  gap: 3px;
}

.screener-table-advanced-cell-value {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);
}

.screener-table-advanced-cell-unit {
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  color: var(--text-primary);
}

/* Sorting */
.screener-table-sorting {
  display: flex;
  align-items: center;

  svg {
    width: 20px;
    height: 20px;
  }
}

.screener-table-sorting-desc-icon path {
  fill: var(--color-brand);
}

/* Sticky Table Header Border */
/* .screener-table-header-border::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background-color: #121212;
} */
`, "",{"version":3,"sources":["webpack://./src/Components/Screener/ScreenerTable.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB,UAAU;;AAEV;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,2BAA2B;EAC3B,SAAS;EACT,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,2BAA2B;EAC3B,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,8BAA8B;EAC9B,wBAAwB;EACxB,2BAA2B;EAC3B,WAAW;EACX,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;EACxB,2BAA2B;EAC3B,WAAW;EACX,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,8BAA8B;EAC9B,iCAAiC;EACjC,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,UAAU;EACV,oBAAoB;AACtB;;AAEA,UAAU;AACV;;EAEE,6BAA6B;EAC7B,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA,QAAQ;AACR;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA,SAAS;;AAET;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,kBAAkB;AAClB;;EAEE,yDAAyD;EACzD,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,UAAU;AACV;;EAEE,6BAA6B;EAC7B,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,iFAAiF;AACjF;;EAEE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,sBAAsB;EACtB,0BAA0B;EAC1B,SAAS;EACT,wCAAwC;EACxC,iCAAiC;EACjC,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,sBAAsB;EACtB,0BAA0B;EAC1B,UAAU;EACV,wCAAwC;EACxC,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;EACT,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;;EAEzB;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;;EAE7B,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,kBAAkB;AACpB;;AAEA;;EAEE,6BAA6B;EAC7B,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,QAAQ;AACR;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,aAAa;AACb;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,sBAAsB;EACtB,0CAA0C;;EAE1C,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;;EAEnB;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,+BAA+B;AAC/B;;;;;;;;GAQG","sourcesContent":["/* Normal Table */\n/* Index */\n\n.screener-table-header-index {\n  z-index: 3 !important;\n  position: relative !important;\n}\n\n.screener-table-header-index,\n.screener-table-index {\n  width: 40px !important;\n  min-width: 40px !important;\n  max-width: 40px !important;\n  position: -webkit-sticky;\n  position: sticky !important;\n  left: 0px;\n  background-color: var(--surface-primary);\n  box-sizing: content-box !important;\n}\n\n.screener-table-header-index {\n  text-align: end !important;\n}\n\n.screener-table-index {\n  text-align: center !important;\n}\n\n.screener-table-header-index-container {\n  width: 100%;\n  padding-left: 16px;\n  text-align: left;\n}\n\n/* Country */\n.screener-table-header-country {\n  z-index: 3 !important;\n  position: relative !important;\n}\n\n.screener-table-header-country,\n.screener-table-country {\n  width: 44px !important;\n  min-width: 44px !important;\n  max-width: 44px !important;\n  position: -webkit-sticky;\n  position: sticky !important;\n  left: 72px;\n  background-color: var(--surface-primary);\n}\n\n.screener-table-country {\n  text-align: center !important;\n  vertical-align: middle !important;\n}\n\n.screener-table-cell-country {\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  padding: 0px 16px 0px 8px !important;\n}\n\n.screener-table-cell-country svg {\n  width: 20px !important;\n  height: 20px !important;\n}\n\n/* Ticker */\n.screener-table-header-ticker-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.screener-table-header-ticker-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n  gap: 2px;\n}\n\n.screener-table-header-ticker {\n  z-index: 3 !important;\n  position: relative !important;\n}\n\n.screener-table-header-ticker,\n.screener-table-ticker {\n  width: 85px !important;\n  min-width: 85px !important;\n  max-width: 85px !important;\n  padding-right: 16px !important;\n  position: -webkit-sticky;\n  position: sticky !important;\n  left: 116px;\n  background-color: var(--surface-primary);\n  box-sizing: content-box !important;\n}\n\n.screener-table-ticker {\n  font-weight: 700 !important;\n  font-size: 16px !important;\n  line-height: 24px !important;\n  color: var(--text-ticker) !important;\n}\n\n.screener-table-cell-ticker {\n  width: fit-content;\n  cursor: pointer;\n}\n\n/* Company Name */\n.screener-table-header-name {\n  z-index: 3 !important;\n  position: relative !important;\n}\n\n.screener-table-header-name-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.screener-table-header-name-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n}\n\n.screener-table-header-name,\n.screener-table-name {\n  width: 200px !important;\n  min-width: 200px !important;\n  max-width: 200px !important;\n  position: -webkit-sticky;\n  position: sticky !important;\n  left: 217px;\n  background-color: var(--surface-primary);\n  white-space: nowrap !important;\n}\n\n/* .screener-table-header-name::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    width: 1px;\n    background-color: #E0E0E0;\n    z-index: 4;\n    pointer-events: none;\n} */\n\n.screener-table-name {\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n  box-sizing: border-box !important;\n  position: relative;\n  width: 200px !important;\n  min-width: 200px !important;\n  max-width: 200px !important;\n}\n\n.screener-table-cell-name {\n  color: var(--text-instrument);\n}\n\n.screener-table-name > * {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.screener-table-name::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 1px;\n  background-color: #e0e0e0;\n  z-index: 4;\n  pointer-events: none;\n}\n\n/* Today */\n.screener-table-header-today,\n.screener-table-today {\n  padding-left: 16px !important;\n  width: 65px !important;\n  min-width: 65px !important;\n  max-width: 65px !important;\n  text-align: right !important;\n  overflow: hidden;\n  box-sizing: content-box !important;\n}\n\n.screener-table-today-chart {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.screener-table-today img {\n  width: 100% !important;\n  height: 32px !important;\n  min-height: 32px !important;\n  object-fit: contain;\n  display: block;\n}\n\n/* Last price */\n.screener-table-header-last {\n  min-width: 110px !important;\n}\n\n.screener-table-header-last-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  cursor: pointer;\n}\n\n.screener-table-header-last,\n.screener-table-last {\n  padding-left: 16px !important;\n  text-align: right !important;\n}\n\n/* Ccy */\n.screener-table-header-ccy {\n  padding-left: 16px !important;\n  width: 48px !important;\n  text-align: right !important;\n}\n\n.screener-table-header-ccy-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  cursor: pointer;\n}\n\n.screener-table-ccy {\n  font-weight: 400 !important;\n  font-size: 12px !important;\n  line-height: 20px !important;\n  text-align: right !important;\n  color: var(--text-secondary) !important;\n}\n\n/* %Chg */\n\n.screener-table-pc {\n  padding-left: 16px !important;\n}\n\n.screener-table-header-pc {\n  min-width: 80px !important;\n  text-align: right !important;\n}\n\n.screener-table-header-pc-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: start;\n  height: 100%;\n  cursor: pointer;\n}\n\n.screener-table-cell-pc {\n  color: var(--text-unchg-color) !important;\n  font-weight: 400 !important;\n  text-align: right !important;\n}\n\n.screener-table-cell-pc.positive {\n  color: var(--text-up-color) !important;\n}\n\n.screener-table-cell-pc.negative {\n  color: var(--text-down-color) !important;\n}\n\n/* Compact Table */\n.screener-compact-table-header-name,\n.screener-compact-table-name {\n  border-right: 1px solid var(--border-tertiary) !important;\n  white-space: nowrap !important;\n}\n\n.screener-compact-table-cell-name-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.screener-compact-table-cell-ticker {\n  width: fit-content;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  text-decoration: underline;\n  color: var(--text-ticker);\n  cursor: pointer;\n}\n\n.screener-compact-table-cell-name {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--text-primary);\n}\n\n/* Today */\n.screener-compact-table-header-today,\n.screener-compact-table-today {\n  padding-left: 16px !important;\n  width: 65px !important;\n  min-width: 65px !important;\n  max-width: 65px !important;\n  text-align: right !important;\n  overflow: hidden;\n  box-sizing: border-box !important;\n}\n\n.screener-compact-table-today-chart {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.screener-compact-table-today img {\n  width: 100% !important;\n  height: 32px !important;\n  min-height: 32px !important;\n  object-fit: contain;\n  display: block;\n}\n\n/* Last price */\n.screener-compact-table-header-last {\n  min-width: 110px !important;\n  text-align: right !important;\n}\n\n.screener-compact-table-cell-last-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: center;\n}\n\n.screener-compact-table-cell-last {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-primary);\n}\n\n.screener-compact-table-cell-last-ccy {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  color: #3c3c4380;\n}\n\n/* %Chg */\n.screener-compact-table-header-pc {\n  min-width: 80px !important;\n  text-align: right !important;\n}\n\n.screener-compact-table-header-pc-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: center;\n}\n\n.screener-compact-table-cell-pc-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: center;\n}\n\n.screener-compact-table-cell-pc {\n  font-weight: 400 !important;\n  text-align: right !important;\n}\n\n.screener-compact-table-cell-pc.positive {\n  color: var(--text-up-color) !important;\n}\n\n.screener-compact-table-cell-pc.negative {\n  color: var(--text-down-color) !important;\n}\n\n.screener-compact-table-cell-nc {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--text-primary);\n}\n\n/* ---------------------------- Small Screen Table ---------------------------- */\n.screener-small-screen-table-header-name,\n.screener-small-screen-table-header-ticker {\n  z-index: 3 !important;\n  position: relative !important;\n}\n\n.screener-small-screen-table-header-name-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.screener-small-screen-table-header-name-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n}\n\n.screener-small-screen-table-header-ticker {\n  position: -webkit-sticky;\n  position: sticky !important;\n  width: 89px !important;\n  max-width: 89px !important;\n  left: 0px;\n  background-color: var(--surface-primary);\n  box-sizing: border-box !important;\n  padding-left: 16px !important;\n  padding-bottom: 8px !important;\n}\n\n.screener-small-screen-table-header-name {\n  position: -webkit-sticky;\n  position: sticky !important;\n  width: 81px !important;\n  max-width: 81px !important;\n  left: 89px;\n  background-color: var(--surface-primary);\n  box-sizing: border-box !important;\n  padding-bottom: 8px !important;\n}\n\n.screener-small-screen-table-name {\n  position: -webkit-sticky;\n  position: sticky !important;\n  width: 170px !important;\n  max-width: 170px !important;\n  left: 0px;\n  background-color: var(--surface-primary);\n  box-sizing: border-box !important;\n}\n\n.screener-small-screen-table-name {\n  overflow: hidden !important;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  position: relative;\n}\n\n.screener-small-screen-table-name::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 1px;\n  background-color: #e0e0e0;\n  z-index: 4;\n  pointer-events: none;\n}\n\n.screener-small-screen-table-cell-name-container {\n  width: 100%;\n  min-width: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  overflow: hidden;\n}\n\n.screener-small-screen-table-cell-name-icon {\n  padding: 4px 16px 0px 0px;\n\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.screener-small-screen-table-cell-name-content {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  cursor: auto;\n}\n\n.screener-small-screen-table-cell-ticker {\n  width: fit-content;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-ticker);\n  cursor: pointer;\n}\n\n.screener-small-screen-table-cell-name {\n  width: 100%;\n  min-width: 0;\n\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--text-instrument);\n\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n/* Today */\n.screener-small-screen-table-header-today {\n  position: relative;\n}\n\n.screener-small-screen-table-header-today,\n.screener-small-screen-table-today {\n  padding-left: 16px !important;\n  width: 65px !important;\n  min-width: 65px !important;\n  max-width: 65px !important;\n  text-align: right !important;\n  overflow: hidden;\n  box-sizing: border-box !important;\n}\n\n.screener-small-screen-table-today-chart {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.screener-small-screen-table-today img {\n  width: 100% !important;\n  height: 32px !important;\n  min-height: 32px !important;\n  object-fit: contain;\n  display: block;\n}\n\n/* Last price */\n.screener-small-screen-table-header-last {\n  position: relative;\n  text-align: right !important;\n  min-width: 65px !important;\n  padding-left: 16px !important;\n}\n\n.screener-small-screen-table-header-last-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  cursor: pointer;\n}\n\n.screener-small-screen-table-last {\n  padding-left: 16px !important;\n}\n\n.screener-small-screen-table-cell-last-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: center;\n}\n\n.screener-small-screen-table-cell-last {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-primary);\n}\n\n/* Ccy */\n.screener-small-screen-table-header-ccy {\n  position: relative;\n  text-align: right !important;\n  min-width: 65px !important;\n  padding-left: 16px !important;\n}\n\n.screener-small-screen-table-header-ccy-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  cursor: pointer;\n}\n\n.screener-small-screen-table-cell-ccy {\n  text-align: right;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  color: #3c3c4380;\n}\n\n/* %Chg */\n.screener-small-screen-table-pc {\n  padding-left: 16px !important;\n}\n\n.screener-small-screen-table-header-pc {\n  position: relative;\n  text-align: right !important;\n  min-width: 65px !important;\n  padding-left: 16px !important;\n}\n\n.screener-small-screen-table-header-pc-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: center;\n}\n\n.screener-small-screen-table-cell-pc {\n  text-align: right;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: #1e1f2f;\n}\n\n.screener-small-screen-table-cell-pc.positive {\n  color: var(--text-up-color) !important;\n}\n\n.screener-small-screen-table-cell-pc.negative {\n  color: var(--text-down-color) !important;\n}\n\n/* Advanced */\n.screener-table-header-advanced {\n  min-width: 100px !important;\n  text-align: right !important;\n  padding-left: 16px !important;\n}\n\n.screener-table-header-advanced-container {\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: start;\n  justify-content: flex-end;\n}\n\n.screener-table-header-advanced-wrapper {\n  cursor: pointer;\n}\n\n.screener-table-header-advanced-title .screener-table-sorting {\n  flex-shrink: 0;\n}\n\n.screener-table-header-advanced-title {\n  max-width: 138px;\n  gap: 2px;\n  display: flex;\n  align-items: center;\n  text-align: right;\n  white-space: nowrap;\n}\n\n.screener-table-header-advanced-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.screener-table-advanced {\n  padding-left: 16px !important;\n  text-align: right !important;\n}\n\n.screener-table-advanced-score {\n  width: 40px;\n  height: 24px;\n\n  justify-self: flex-end;\n  background-color: var(--surface-secondary);\n\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-size: 16px;\n  text-align: center;\n  color: var(--text-primary);\n}\n\n.screener-table-advanced-cell-container {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  justify-content: flex-end;\n  gap: 3px;\n}\n\n.screener-table-advanced-cell-value {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-primary);\n}\n\n.screener-table-advanced-cell-unit {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 100%;\n  color: var(--text-primary);\n}\n\n/* Sorting */\n.screener-table-sorting {\n  display: flex;\n  align-items: center;\n\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.screener-table-sorting-desc-icon path {\n  fill: var(--color-brand);\n}\n\n/* Sticky Table Header Border */\n/* .screener-table-header-border::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 1px;\n    background-color: #121212;\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
